import { Rank } from '../../sim/defs';
import { defineEnemy, Motion } from '../schema';

/** E-M10b — BULLE. La coque du Kyste.
 *
 *  Une partie destructible ordinaire — un ennemi comme un autre, qui se trouve
 *  avoir un parent — posée à l'offset zéro pour ENVELOPPER le noyau. Tant qu'elle
 *  vit, `livingParts` du Kyste renvoie un, et la collision refuse tout tir sur le
 *  noyau : la bulle encaisse tout, de n'importe quelle direction. La crever révèle
 *  le noyau. Rien de spécifique côté moteur : c'est le mécanisme du Bastion,
 *  détourné pour faire un bouclier 360° au lieu d'une tourelle.
 *
 *  ── Pourquoi elle ne tire pas et ne bouge pas ──
 *  Elle est une COQUE, pas une arme : le noyau tire au travers. Et comme toute
 *  partie, elle est repositionnée sur son porteur à chaque tick — sa propre forme
 *  de mouvement n'est jamais lue, d'où l'Anchor inerte. Grande (rayon 48) pour
 *  enfermer visiblement le noyau (24) et pour que ses 250 PV se lisent comme une
 *  vraie coque à percer, pas comme un mince halo.
 *
 *  ── Pas de butin propre ──
 *  Le butin tombe du noyau une fois abattu. Récompenser aussi la bulle doublerait
 *  la mise d'un seul ennemi et fausserait l'économie. */
export default defineEnemy({
  id: 'bulle',
  rank: Rank.Heavy,
  hp: 250,
  visualRadius: 48,
  score: 0,
  telegraph: 0,
  drops: 0,
  // Inerte : une partie ne lit jamais sa propre forme de mouvement, elle colle à
  // son porteur (voir la seconde passe de `motionSystem`).
  motion: { kind: Motion.Anchor, speed: 0, holdY: 320 },
});
